import { useDeleteItemMutation } from '../../../graphql'
import { useShowError, useShowSuccess } from 'hooks/useToast'
import { useNavigate } from 'react-router-dom'

export default function useDeleteItemHandler( options?: any ) {
	const [ createOverride ] = useDeleteItemMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()
	const navigate = useNavigate()

	return async(
		itemId: number,
	) => {
		const result = await createOverride( { variables: {
			id: itemId,
		} } )

		if ( result.data?.archiveStorePart?.success ) {
			showSuccess( `removeItemFromInventory${Date.now()}`, 'Item was successfully deleted.' )
			navigate( -1 )
		} else if ( result.data?.archiveStorePart?.message ) {
			showError( `removeItemFromInventory${Date.now()}`, result.data.archiveStorePart.message )
		}
	}
}
